import { createPrefixer } from '.'

const ROOT = 'ver-caja-chica' as const
export const RESOURCE_CAJA_CHICA = 'Cash' as const

const rp = <T extends string>(mod: T): `${typeof ROOT}-${T}` => `${ROOT}-${mod}`
const pm = createPrefixer(ROOT, 'mantenimiento')
const pt = createPrefixer(ROOT, 'transacciones')
const pc = createPrefixer(ROOT, 'configuracion')
// const pi = createPrefixer(ROOT, 'informes')

const permission = {
    _root: ROOT,
    _resource: RESOURCE_CAJA_CHICA,
    mantenimiento: {
        _perm: rp('mantenimiento'),
        crearCajaChica: pm('crear-caja-chica'),
        crearTipoGasto: pm('crear-tipo-gasto'),
    },
    configuracion: {
        _perm: rp('configuracion'),
        permisoAprobarVale: pc('permiso-aprobar-vale'),
    },
    transacciones: {
        _perm: rp('transacciones'),
        valesCaja: {
            _pem: pt('vales-caja-chica'),
            valeCaja: pt('vale-caja-chica'),
            aprobacionValeCaja: pt('aprobacion-vale-caja'),
        },
        reposicionesCaja: {
            _pem: pt('reposiciones-caja-chica'),
            reposicionCaja: pt('reposicion-caja-chica'),
        },
    },
    informes: {},
    actions: {},
}

export default permission
